const angular = require('angular');
const app = angular.module('learn-directives');
/**
 * Defines the email template component
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 */
app.directive('scheduler', [function () {
  return {
    restrict: 'E',
    replace: true,
    scope: {
      contentType: '=',
      content: '=',
      slackAvailable: '=',
      isMultiSessionWorkshop: '='
    },
    template: require('../../../templates/directives/messaging/scheduler.html'),
    controller: ['$scope', function ($scope) {
      var self = this;

      self.helptext = '';

      self.templateOptions = {
        on_register_msw: '<p dir="ltr"><span style="font-size:10.5pt;font-family:Arial;color:#000000;">Hi {recipient_first_name},</span><span style="font-size:10.5pt;font-family:Arial;color:#000000;"><br></span><span style="font-size:10.5pt;font-family:Arial;color:#000000;"><br></span><span style="font-size:10.5pt;font-family:Arial;color:#000000;">Thanks for registering to attend the Multi Session Workshop&nbsp;</span><span style="font-size:10.5pt;font-family:Arial;color:#000000;"><em>{workshop_title}</em></span><span style="font-size:10.5pt;font-family:Arial;color:#000000;">. &nbsp;We&#39;re excited for you to join us!</span><span style="font-size:10.5pt;font-family:Arial;color:#000000;"><br></span><span style="font-size:10.5pt;font-family:Arial;color:#000000;"><br></span><p><span style="font-size:10.5pt;font-family:Arial;color:#000000;">If you have any questions before the workshop starts, please feel free to reach out to&nbsp;</span><span style="font-size:10.5pt;font-family:Arial;color:#000000;"><em>{creator_full_name}</em>.</span><span style="font-size:10.5pt;font-family:Arial;color:#000000;"><br></span><span style="font-size:10.5pt;font-family:Arial;color:#000000;"><br></span><span style="font-size:10.5pt;font-family:Arial;color:#000000;">See you soon!</span><span style="font-size:10.5pt;font-family:Arial;color:#000000;"><br></span><span style="font-size:10.5pt;font-family:Arial;color:#000000;">The {company} Team</span></p>',
        on_register:  '<p dir="ltr"><span style="font-size:10.5pt;font-family:Arial;color:#000000;">Hi {recipient_first_name},</span><span style="font-size:10.5pt;font-family:Arial;color:#000000;"><br></span><span style="font-size:10.5pt;font-family:Arial;color:#000000;"><br></span><span style="font-size:10.5pt;font-family:Arial;color:#000000;">Thanks for registering to attend&nbsp;</span><span style="font-size:10.5pt;font-family:Arial;color:#000000;"><em>{workshop_title}</em></span><span style="font-size:10.5pt;font-family:Arial;color:#000000;">. &nbsp;We&#39;re excited for you to join us!</span><span style="font-size:10.5pt;font-family:Arial;color:#000000;"><br></span><span style="font-size:10.5pt;font-family:Arial;color:#000000;"><br></span><span style="font-size:10.5pt;font-family:Arial;color:#000000;">Here are the details:</span></p><p dir="ltr"><span style="font-size:10.5pt;font-family:Arial;color:#000000;"><strong>{workshop_title}</strong></span><span style="font-size:10.5pt;font-family:Arial;color:#000000;"><br></span><span style="font-size:10.5pt;font-family:Arial;color:#000000;">{workshop_start_date}</span><span style="font-size:10.5pt;font-family:Arial;color:#000000;"><br></span><span style="font-size:10.5pt;font-family:Arial;color:#000000;">{workshop_start_time} - {workshop_end_time}</span><span style="font-size:10.5pt;font-family:Arial;color:#000000;"><br></span><span style="font-size:10.5pt;font-family:Arial;color:#000000;"><strong>{workshop_location}</strong></span></p><p><span style="font-size:10.5pt;font-family:Arial;color:#000000;">If you have any questions before the workshop starts, please feel free to reach out to&nbsp;</span><span style="font-size:10.5pt;font-family:Arial;color:#000000;"><em>{host_name}</em>.</span><span style="font-size:10.5pt;font-family:Arial;color:#000000;"><br></span><span style="font-size:10.5pt;font-family:Arial;color:#000000;"><br></span><span style="font-size:10.5pt;font-family:Arial;color:#000000;">See you soon!</span><span style="font-size:10.5pt;font-family:Arial;color:#000000;"><br></span><span style="font-size:10.5pt;font-family:Arial;color:#000000;">{sender_first_name}</span></p>',
        before_start: '<p dir="ltr"><span style="font-size:10.5pt;font-family:Arial;color:#000000;">Hi {recipient_first_name},</span><span style="font-size:10.5pt;font-family:Arial;color:#000000;"><br></span><span style="font-size:10.5pt;font-family:Arial;color:#000000;"><br></span><span style="font-size:10.5pt;font-family:Arial;color:#000000;">Just a friendly reminder that you&rsquo;re registered for&nbsp;</span><span style="font-size:10.5pt;font-family:Arial;color:#000000;"><em>{workshop_title}</em></span><span style="font-size:10.5pt;font-family:Arial;color:#000000;">.&nbsp;</span><span style="font-size:10.5pt;font-family:Arial;color:#000000;"><br></span><span style="font-size:10.5pt;font-family:Arial;color:#000000;"><br></span><span style="font-size:10.5pt;font-family:Arial;color:#000000;">Here are the details:</span></p><p dir="ltr"><span style="font-size:10.5pt;font-family:Arial;color:#000000;"><strong>{workshop_title}</strong></span><span style="font-size:10.5pt;font-family:Arial;color:#000000;"><br></span><span style="font-size:10.5pt;font-family:Arial;color:#000000;">{workshop_start_date}</span><span style="font-size:10.5pt;font-family:Arial;color:#000000;"><br></span><span style="font-size:10.5pt;font-family:Arial;color:#000000;">{workshop_start_time} - {workshop_end_time}</span><span style="font-size:10.5pt;font-family:Arial;color:#000000;"><br></span><span style="font-size:10.5pt;font-family:Arial;color:#000000;"><strong>{workshop_location}</strong></span></p><p><span style="font-size:10.5pt;font-family:Arial;color:#000000;">If you have any questions before the workshop starts, please feel free to reach out to&nbsp;</span><span style="font-size:10.5pt;font-family:Arial;color:#000000;"><em>{host_name}</em>.</span><span style="font-size:10.5pt;font-family:Arial;color:#000000;"><br></span><span style="font-size:10.5pt;font-family:Arial;color:#000000;"><br></span><span style="font-size:10.5pt;font-family:Arial;color:#000000;">See you soon!</span><span style="font-size:10.5pt;font-family:Arial;color:#000000;"><br></span><span style="font-size:10.5pt;font-family:Arial;color:#000000;">{sender_first_name}</span></p>',
        after_end: '<p><span style="font-size:10.5pt;font-family:Arial;color:#000000;">Hi {recipient_first_name},</span><span style="font-size:10.5pt;font-family:Arial;color:#000000;"><br></span><span style="font-size:10.5pt;font-family:Arial;color:#000000;"><br></span><span style="font-size:10.5pt;font-family:Arial;color:#000000;">Thanks for attending&nbsp;</span><span style="font-size:10.5pt;font-family:Arial;color:#000000;"><em>{workshop_title}</em></span><span style="font-size:10.5pt;font-family:Arial;color:#000000;">. It was great to have you with us!</span><span style="font-size:10.5pt;font-family:Arial;color:#000000;"><br></span><span style="font-size:10.5pt;font-family:Arial;color:#000000;"><br></span><span style="font-size:10.5pt;font-family:Arial;color:#000000;"><em>Have any questions or feedback on the workshop? Please feel to reach out directly to {host_name}</em>.</span></p>',
        slackRegister: "Thanks for registering to attend {workshop_title}.  We're excited for you to join us! \n If you have any questions before the workshop starts, please feel free to reach out to {host_name}.",
        inAppRegister: "Thanks for registering to attend {workshop_title}.  We're excited for you to join us! \n If you have any questions before the workshop starts, please feel free to reach out to {host_name}.",
        inAppRegisterMsw: "Thanks for registering to attend {workshop_title}.  We're excited for you to join us! \n If you have any questions before the workshop starts, please feel free to reach out to {creator_full_name}."
      };

      if ($scope.isMultiSessionWorkshop) {
        self.scheduled = false;
        self.onRegister = true;
      }


        self.parseUnits = function() {
        self.selectedUnits = 'hours';
        self.selectedDuration = 1;
        if (!$scope.content.scheduled_duration) {
          return;
        }
        if ($scope.content.scheduled_duration < (60 * 60 * 24)) {
          self.selectedDuration = $scope.content.scheduled_duration / 60 / 60;
          return;
        }

        self.selectedUnits = 'days';
        self.selectedDuration = $scope.content.scheduled_duration / 60 / 60 / 24;
      };

      self.parseAudience = function() {
        self.showRegistered = false;
        self.showAttended = false;
        if (!$scope.content.options) {
          $scope.content.options = [];
        }

        if (!$scope.content.options.length) {
          $scope.content.options.push({name: 'audience', value: 'registered'});
        }

        $scope.content.options.forEach(function(item) {
          if (item.name === 'audience') {
            if (item.value === 'registered') {
              self.showRegistered = true;
            }
            if (item.value === 'attended') {
              self.showAttended = true;
            }
          }
        });
      };

      self.update = function(schedule) {
        if (schedule) {
          self.onRegister = false;
          if ($scope.content.type === 'on_register') {
            $scope.content.type = 'before_start';
          }
        }

        if (!schedule && self.onRegister) {
          $scope.content.type = 'on_register'
        }

        if ($scope.content.type !== 'on_register') {
          $scope.content.scheduled = true;

          // Handle Duration
          var duration = self.selectedDuration * 60 * 60;
          if (self.selectedUnits === 'days') {
            duration = duration * 24;
          }
          $scope.content.scheduled_duration = duration;
          // Handle Audience
          var checked = {registered: false, attended: false};
          for (var i = $scope.content.options.length - 1; i >= 0; i--) {
            if ($scope.content.options[i].name && $scope.content.options[i].name === 'audience') {
              if ($scope.content.options[i].value === 'registered') {
                checked.registered = true;
                if (!self.showRegistered && $scope.content.type !== 'before_start') {
                  $scope.content.options.splice(i, 1);
                }
                continue;
              }
              if ($scope.content.options[i].value === 'attended') {
                checked.attended = true;
                if (!self.showAttended || $scope.content.type === 'before_start') {
                  $scope.content.options.splice(i, 1);
                }
                continue;
              }
            }
          }

          if (!checked.registered && (self.showRegistered || $scope.content.type === 'before_start')) {
            $scope.content.options.push({name: 'audience', value: 'registered'});
          }

          if (!checked.attended && $scope.content.type === 'after_end' && self.showAttended) {
            $scope.content.options.push({name: 'audience', value: 'attended'});
          }
        }

        if ($scope.content.type === 'on_register') {
          $scope.content.scheduled = false;
        }

        // Handle channels
        var channels = [];
        if (!self.channels.in_app && !self.channels.email && !self.channels.slack) {
          self.channels.email = true;
        }

        if (self.channels.email) {
          channels.push('email');
        }
        if (self.channels.in_app) {
          channels.push('in_app');
        }
        if (self.channels.slack) {
          channels.push('slack');
        }

        $scope.content.channels = channels;

        // Set default email if none has been set yet
        if ($scope.content.messaging && $scope.content.messaging.email) {
          var bodyChecked;
          $scope.content.messaging.email.forEach(function(item) {
            if (item.name === 'body') {
              bodyChecked = true;
            }
          });

          if (!bodyChecked) {
            $scope.content.messaging.email.push({name: 'body', value: self.templateOptions[$scope.content.type]});
          }
        }
      };

      self.timeUnits = [{name: 'Hours', value: 'hours'}, {name: 'Days', value: 'days'}];
      self.chronologyOptions = [{name: 'Before', value: 'before_start'}, {name: 'After', value: 'after_end'}];

      self.channels = {
        in_app: false,
        email: false,
        slack: false
      };

      var getBody = function(type, item) {
        if (!item.messaging || !item.messaging[type] || !item.messaging[type].length) {
          return '';
        }
        for (var i = 0; i < item.messaging[type].length; i++) {
          if (item.messaging[type][i].name === 'body') {
            return item.messaging[type][i].value;
          }
        }
        return '';
      };

      var setBody = function(type, text) {
        if (!$scope.content.messaging || !$scope.content.messaging[type]) {
          return '';
        }
        for(var i = 0; i < $scope.content.messaging[type].length; i++) {
          if ($scope.content.messaging[type][i].name === 'body') {
            $scope.content.messaging[type][i].value = text;
            return;
          }
        }
        $scope.content.messaging[type].push({name: 'body', value: text});
      };

      var checkSlackOptions = function() {
        if ($scope.contentType === 'Workshop' && $scope.content.type === 'after_end') {
          $scope.content.messaging.slack.forEach(function(item) {
            if (item.name === 'include_template' && item.value === 'active') {
              item.value = 'inactive';
            }
          });
        }
      };

      self.increaseTime = function() {
        self.selectedDuration = self.selectedDuration + 1;
      };

      self.decreaseTime = function() {
        if (!self.selectedDuration || self.selectedDuration < 2) {
          self.selectedDuration = 2;
        }
        self.selectedDuration = self.selectedDuration - 1;
      };

      self.initialize = function() {
        if ($scope.content.type === 'on_register') {
          self.onRegister = true;
        }
        $scope.content.channels.forEach(function(channel) {
          self.channels[channel] = true;
        });
        self.parseAudience();
        self.parseUnits();
      };

      self.initialize();

      $scope.$watch('content', function(newVal, oldVal) {
        if (!newVal || !oldVal) {
          return;
        }
        if (newVal.type !== oldVal.type) {
          var slackBody = getBody('slack', oldVal);
          var inAppBody = getBody('in_app', oldVal);
          var body = getBody('email', oldVal);
          // If the template has been changed - do not reset
          if (body && body !== self.templateOptions[oldVal.type]) {
            return;
          }
          // If there is no template, or its the default - set the new default
          if ($scope.isMultiSessionWorkshop) {
            setBody('email', self.templateOptions.on_register_msw);
          } else {
            setBody('email', self.templateOptions[newVal.type]);
          }
          checkSlackOptions();

          if (newVal.type === 'on_register') {
            if (!slackBody) {
              setBody('slack', self.templateOptions.slackRegister);
            }
            if (!inAppBody) {
              if ($scope.isMultiSessionWorkshop) {
                setBody('in_app', self.templateOptions.inAppRegisterMsw);
              } else {
                setBody('in_app', self.templateOptions.inAppRegister);
              }
            }
          } else {
            if (slackBody === self.templateOptions.slackRegister) {
              setBody('slack', '');
            }
            if (inAppBody === self.templateOptions.inAppRegister) {
              setBody('in_app', '');
            }
          }
        }
      }, true);

      $scope.$watch('schedule.selectedUnits', function(newVal, oldVal) {
        if (newVal === 'hours') {
          if (self.selectedDuration > 23) {
            self.selectedDuration = 23;
          }
        }
        self.update();
      });

      $scope.$watch('schedule.selectedDuration', function(newVal, oldVal) {
        if (!self.selectedDuration) {
          self.selectedDuration = 91;
        }
        if (self.selectedDuration < 2) {
          self.selectedDuration = 1;
        }
        if (self.selectedUnits === 'hours' && self.selectedDuration > 23) {
          self.selectedDuration = 23;
        }
        if (self.selectedUnits === 'days' && self.selectedDuration > 90) {
          self.selectedDuration = 90;
        }
        self.update();
      });

    }],
    controllerAs: 'schedule'
  }
}]);